<template lang="pug">
  BAutocomplete(
    id="timezone"
    :data="filteredTimezones"
    v-model="optionName"
    :open-on-focus="true"
    :clearable="true"
    field="name"
    placeholder="Select a timezone"
    dropdown-position="bottom"
    :keep-first="true"
    @select="value => $emit('update', value)"
  )
</template>

<script>
export default {
  name: "WtTimezoneSelect",

  props: {
    timezone: {
      type: Object,
      default: null
    },

    initialOffset: {
      type: String,
      default: ""
    }
  },

  data() {
    return {
      optionName: "",
      timezones: [
        { name: "(GMT -12:00) Eniwetok, Kwajalein", value: "-12" },
        { name: "(GMT -11:00) Midway Island, Samoa", value: "-11" },
        { name: "(GMT -10:00) Hawaii", value: "-10" },
        { name: "(GMT -9:30) Taiohae", value: "-9.5" },
        { name: "(GMT -9:00) Alaska", value: "-9" },
        { name: "(GMT -8:00) Pacific Time (US & Canada)", value: "-8" },
        { name: "(GMT -7:00) Mountain Time (US & Canada)", value: "-7" },
        {
          name: "(GMT -6:00) Central Time (US & Canada), Mexico City",
          value: "-6"
        },
        {
          name: "(GMT -5:00) Eastern Time (US & Canada), Bogota, Lima",
          value: "-5"
        },
        { name: "(GMT -4:30) Caracas", value: "-4.5" },
        {
          name: "(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz",
          value: "-4"
        },
        { name: "(GMT -3:30) Newfoundland", value: "-3.5" },
        { name: "(GMT -3:00) Brazil, Buenos Aires, Georgetown", value: "-3" },
        { name: "(GMT -2:00) Mid-Atlantic", value: "-2" },
        { name: "(GMT -1:00) Azores, Cape Verde Islands", value: "-1" },
        {
          name: "(GMT) Western Europe Time, London, Lisbon, Casablanca",
          value: "0"
        },
        { name: "(GMT +1:00) Brussels, Copenhagen, Madrid, Paris", value: "1" },
        { name: "(GMT +2:00) Kaliningrad, South Africa", value: "2" },
        { name: "(GMT +3:30) Tehran", value: "3.5" },
        {
          name: "(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg",
          value: "3"
        },
        { name: "(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi", value: "4" },
        { name: "(GMT +4:30) Kabul", value: "4.5" },
        { name: "(GMT +5:45) Kathmandu, Pokhara", value: "5.75" },
        {
          name: "(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent",
          value: "5"
        },
        {
          name: "(GMT +5:30) Bombay, Calcutta, Madras, New Delhi",
          value: "5.5"
        },
        { name: "(GMT +6:00) Almaty, Dhaka, Colombo", value: "6" },
        { name: "(GMT +6:30) Yangon, Mandalay", value: "6.5" },
        { name: "(GMT +7:00) Bangkok, Hanoi, Jakarta", value: "7" },
        { name: "(GMT +8:45) Eucla", value: "8.75" },
        {
          name: "(GMT +8:00) Beijing, Perth, Singapore, Hong Kong",
          value: "8"
        },
        { name: "(GMT +9:30) Adelaide, Darwin", value: "9.5" },
        {
          name: "(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk",
          value: "9"
        },
        { name: "(GMT +14:00) Line Islands, Tokelau", value: "14" },
        { name: "(GMT +10:30) Lord Howe Island", value: "10.5" },
        {
          name: "(GMT +10:00) Eastern Australia, Guam, Vladivostok",
          value: "10"
        },
        { name: "(GMT +11:30) Norfolk Island", value: "11.5" },
        {
          name: "(GMT +11:00) Magadan, Solomon Islands, New Caledonia",
          value: "11"
        },
        { name: "(GMT +12:45) Chatham Islands", value: "12.75" },
        {
          name: "(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka",
          value: "12"
        },
        { name: "(GMT +13:00) Apia, Nukualofa", value: "13" }
      ]
    };
  },

  computed: {
    filteredTimezones() {
      return this.timezones.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.optionName.toLowerCase()) >= 0
        );
      });
    }
  },

  watch: {
    timezone(value) {
      this.optionName = value.name;
    }
  },

  mounted() {
    let timezone = {};

    if (this.initialOffset) {
      timezone = this.timezones[
        this._.findIndex(this.timezones, tz => {
          return tz.value === this.initialOffset;
        })
      ];

      this.optionName = timezone.name;
      this.$emit("update", timezone);
    }
  }
};
</script>

<style lang="sass" scoped></style>
